 (function () {
    function getVariantIdFromUrl(url) {
      if (!url) return null;
      try {
        return new URL(url, window.location.origin).searchParams.get('variant');
      } catch (e) {
        const match = String(url).match(/[?&]variant=(\d+)/);
        return match ? match[1] : null;
      }
    }

    function setCardVariantId(card, variantId) {
      if (!card || !variantId) return;

      let input = card.querySelector('.klip-card-variant-id');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        input.className = 'klip-card-variant-id';

        const box = card.querySelector('.elsklip-coupon-box');
        if (box) box.insertAdjacentElement('afterend', input);
        else card.appendChild(input);
      }

      if (String(input.value) !== String(variantId)) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    document.addEventListener('change', function (event) {
      const option = event.target.closest('.opt-btn[data-variant-id]');
      if (!option) return;

      const card = option.closest('product-card, .card--product');
      setCardVariantId(card, option.dataset.variantId);
    }, true);

    document.addEventListener('vsk:variant:changed', function (event) {
      const card = event.target.closest('product-card, .card--product') || event.target;
      if (!card || !card.matches?.('product-card, .card--product')) return;

      let variantId = null;

      try {
        const info = JSON.parse(event.detail?.variantInformation || '{}');
        variantId = info.id || info.variantId || info.variant?.id || info.admin_graphql_api_id;
        if (typeof variantId === 'string') {
          const match = variantId.match(/(\d+)$/);
          variantId = match ? match[1] : variantId;
        }
      } catch (e) {}

      if (!variantId) {
        variantId = getVariantIdFromUrl(card.querySelector('.js-prod-link[href*="variant="]')?.href);
      }

      setCardVariantId(card, variantId);
    }, true);

    document.addEventListener('click', function (event) {
      const card = event.target.closest('product-card, .card--product');
      if (!card) return;

      setTimeout(function () {
        const variantId = getVariantIdFromUrl(card.querySelector('.js-prod-link[href*="variant="]')?.href);
        setCardVariantId(card, variantId);
      }, 50);
    }, true);
  })();
